<template>
  <div class="test" ref="test">
    <div ref="modal12" :style="{ width: imgW + 200 + 'px' }" class="md-modal md-effect-12" id="modal-12">
      <div class="md-content">
        <img v-if="showDetailType <= 1" src :style="{ width: imgW + 'px' }" />
        <video controls="controls" autoplay v-else-if="showDetailType > 1" src :style="{ width: imgW + 'px' }" />
      </div>
    </div>
    <div>
      <div ref="infoDetail" class="infoDetail pointerEvents">
        <warn1-tiny class="warn1-Tiny" :detailData="detailData" :typeId="detailID"></warn1-tiny>
      </div>
      <div
        ref="infoHistory"
        class="infoHistory"
        :class="[
          detailData.warnType == 5 &&
          detailData.chartRoadVDM &&
          detailData.chartRoadPM10
            ? 'infoHistoryNew'
            : detailData.warnType == 5 && detailData.chartRoadVDM
            ? ''
            : 'infoHistoryNew1',
        ]"
      >
        <div class="warn1_title">
          <div class="popup-type1-title" :class="{ 'popup-type1-title_green': treatType }">
            <template v-if="detailData.analyzeResult && detailData.warnType == 5">{{ "道路" }}-{{ "污染识别" }}</template>
            <template v-else-if="detailData.warnType == 3">{{ detailData.eventName }}</template>
            <template v-else-if="detailData.warnType == 18">{{ detailData.eventName }}</template>
            <template v-else-if="detailData.warnType == 1003">{{ detailData.eventName }}</template>
            <template v-else-if="detailData.warnType == 1004">{{ detailData.eventName }}</template>
            <template v-else-if="detailData.warnType == 1005">{{ detailData.eventName }}</template>
            <template v-else>
              {{ detailData.typeName }}-{{
              detailData.metric +
              (detailData.warnType === 1 && detailData.metric === "TSP"
              ? "告警"
              : detailData.warnType === 1 && detailData.metric === "VDM浓度"
              ? "告警"
              : detailData.warnType === 1
              ? "超标"
              : detailData.warnType === 2
              ? "超低"
              : "")
              }}
            </template>
          </div>
          <div class="popup-type1-time">{{ detailData.eventTime ? detailData.eventTime.slice(5, 16) : "" }}</div>
        </div>
        <div v-show="detailData.warnType != 5 && hasChartData" ref="chart" class="historyChart"></div>

        <div v-show="detailData.warnType == 5 && detailData.chartRoadPM10" class="charts-title">PM10均值 μg/m³</div>
        <div v-show="detailData.warnType == 5 && detailData.chartRoadPM10" ref="chart1" class="historyChart1"></div>
        <div v-show="detailData.warnType == 5 && detailData.chartRoadVDM" class="charts-title">VDM均值 μg/m³</div>
        <div v-show="detailData.warnType == 5 && detailData.chartRoadVDM" ref="chart2" class="historyChart2"></div>
      </div>
    </div>
    <div class="processComponent">
      <div class="everyComponent">
        <ul :class="{ noArcgis: !isArcgis }">
          <template v-for="(item, i) in cachePointList">
            <li
              v-show="true"
              :id="'playPos-' + i"
              v-if="
                winPos[i + cacheList.length] &&
                winPos[i + cacheList.length][0] &&
                winPos[i + cacheList.length][3] &&
                item['status'] == 'play'
              "
              :key="i"
              class="ComponentTip_"
              :style="{
                left:
                  (winPos[i + cacheList.length][0] + baseOffSet) / prew -
                  29 +
                  'px',
                bottom: winPos[i + cacheList.length][3] / prew - 32 + 'px',
              }"
            >
              <div v-if="!item.type">
                <img class="red" src="./img/red.png" />
              </div>
              <div v-else-if="item.type">
                <img class="green" src="./img/green.png" />
              </div>
            </li>
          </template>
        </ul>
        <ul>
          <template v-for="(item, i) in cacheList">
            <li
              :id="'playTip-' + i"
              v-if="
                (mapType === 'unity3D' && item['status'] == 'play') ||
                (winPos[i] &&
                  winPos[i][0] &&
                  winPos[i][3] &&
                  item['status'] == 'play')
              "
              :key="i"
              class="ComponentTip"
              :style="{
                left: (winPos[i][0] + +baseOffSet) / prew - 255 + 'px',
                bottom: winPos[i][3] / prew - 160 + 'px',
              }"
            >
              <div class="warn_block" v-if="item.typeId !== '000' && item.typeId !== '同步率'">
                <div class="warn_innerBlock" @mousemove="stopWarning(i)" @mouseenter="stopWarning(i)" @mouseleave="restoreWarning(i)">
                  <warn1 class="warn1" :data="item.data" :typeId="item.typeId"></warn1>
                  <div
                    class="upgrade"
                    v-if="
                      item.data &&
                      item.data.upgradeList &&
                      item.data.upgradeList.length > 0
                    "
                  >
                    <div>管理制度落实</div>
                    <div
                      class="upgrade-lineSteps"
                      :style="{
                        height:
                          (item.data.upgradeList.length - 1) * 98 + 20 + 'px',
                        marginTop: 35 + 'px',
                      }"
                    >
                      <el-steps direction="vertical" :active="item.data.curIdex" process-status="success">
                        <el-step :title="item_.state === 1 ? '已处理' : '处理中'" v-bind:key="j" v-for="(item_, j) in item.data.upgradeList"></el-step>
                        <!--el-step title="步骤 2"></el-step>
                        <el-step
                          title="步骤 3"
                          description="这是一段很长很长很长的描述性文字"
                        ></el-step>
                        <el-step title="步骤 4"></el-step>
                        <el-step title="步骤 5"></el-step-->
                      </el-steps>
                      <ul>
                        <li v-bind:key="j" v-for="(item_, j) in item.data.upgradeList">
                          <div class="upgrade-wrap">
                            <div class="upgrade_pic">
                              <img :src="item_.imgUrl" />
                            </div>
                            <div class="upgrade_person">
                              <div class="upgrade_personName">{{ item_.userName }}</div>
                              <div class="upgrade_officeName">{{ item_.officeName }}</div>
                            </div>
                          </div>
                          <div>{{ item_.date }}</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <img :class="{ img2: true, noArcgis: !isArcgis }" src="./img/4.png" alt />
              </div>
              <div class="warn_block" v-else-if="item.typeId == '000'">
                <div class="warn_innerBlock" @mousemove="stopWarning(i)" @mouseenter="stopWarning(i)" @mouseleave="restoreWarning(i)">
                  <warn2 class="warn2" :data="item.data"></warn2>
                </div>
                <img :class="{ img2: true, noArcgis: !isArcgis }" src="./img/4.png" alt />
              </div>
              <div class="warn_block" v-else-if="item.typeId == '同步率'">
                <div class="warn_innerBlock" @mousemove="stopWarning(i)" @mouseenter="stopWarning(i)" @mouseleave="restoreWarning(i)">
                  <warn3 class="warn3" :data="item.data"></warn3>
                </div>
                <img :class="{ img2: true, noArcgis: !isArcgis }" src="./img/4.png" alt />
              </div>
            </li>
          </template>
        </ul>
        <ul>
          <li :id="'dustTip-0'" class="DustTip" v-if="dustStatus" :style="getDustCurStyle()">
            <div class="trace_source" ref="traceSource">
              <div
                :class="{
                  dustReason: true,
                  dustReasonBlack: styleType != 'typeGreen' ? true : false,
                }"
              >
                <div class="dustReasonTitle">污染决策</div>
                <div>事件原因：{{ eventReason ? eventReason : "--" }}</div>
                <div style="margin-top: 10px">处理措施：{{ eventMeasure ? eventMeasure : "--" }}</div>
              </div>
              <img src="./img/dust.png" class="dustRotate" />
            </div>
          </li>
          <li :id="'dustTip-1'" v-if="true"></li>
        </ul>
        <!--ul>
          <li>
            <div class="trace_source" ref="traceSource">
              <img src="./img/dust.png" />
            </div>
          </li>
        </ul-->
      </div>
    </div>

    <div class="emission_table" @mousemove="stopWarning()" @mouseenter="stopWarning()" @mouseleave="restoreWarning()">
      <el-table
        :data="sourceData"
        :header-cell-class-name="getHeaderCellClass"
        :header-row-class-name="getHeadRowClass"
        :cell-class-name="getCellClass"
        :row-class-name="getRowClass"
        class="source_table"
        ref="sourceTable"
        v-loading="isLoad"
        :element-loading-text="loadStr"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.5)"
        :style="{ marginTop: '10px' }"
        :maxHeight="autoHeight"
        @row-click="rowClick"
        empty-text="--"
      >
        <el-table-column type="index" label="序号" width="45"></el-table-column>
        <el-table-column prop="branchFactory" label="分厂/所属区域" width="130"></el-table-column>
        <el-table-column prop="emName" label="排放源名称" width></el-table-column>
        <el-table-column align="center" header-align="center" label="关联生产设备" width="80">
          <template #default="scope">
            <span v-if="scope.row && scope.row.equipmentName === '1'" class="green-dot">●</span>
            <span
              v-else-if="
                scope.row &&
                (scope.row.equipmentName === 0 ||
                  scope.row.equipmentName === '0')
              "
              class="red-dot"
            >●</span>
            <span
              v-else-if="
                scope.row && typeof scope.row.equipmentName !== 'number'
              "
              :title="scope.row.equipmentName"
              class="gray-dot"
            >-</span>
          </template>
        </el-table-column>
        <el-table-column align="center" header-align="center" label="关联治理设备" width="80">
          <template #default="scope">
            <span v-if="scope.row && scope.row.governmentName === '1'" class="green-dot">●</span>
            <span
              v-else-if="
                scope.row &&
                (scope.row.governmentName === 0 ||
                  scope.row.governmentName === '0')
              "
              class="red-dot"
            >●</span>
            <span
              v-else-if="
                scope.row && typeof scope.row.governmentName !== 'number'
              "
              :title="scope.row.governmentName"
              class="gray-dot"
            >-</span>
          </template>
        </el-table-column>
        <el-table-column align="center" header-align="center" label="关联监测设备" width="80">
          <template #default="scope">
            <span v-if="scope.row && scope.row.monitorName === '1'" class="green-dot">●</span>
            <span
              v-else-if="
                scope.row &&
                (scope.row.monitorName === 0 || scope.row.monitorName === '0')
              "
              class="red-dot"
            >●</span>
            <span v-else-if="scope.row && typeof scope.row.monitorName !== 'number'" :title="scope.row.equipmentName" class="gray-dot">-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <device-bar v-if="deviceStatus"></device-bar>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { mapState, mapGetters } from 'vuex'
import Warn1 from './warn1.vue'
import Warn2 from './warn2.vue'
import Warn3 from './warn3.vue'
import Warn1Tiny from './warn1_tiny.vue'

import deviceBar from '@/modules/unorganizedComponents/deviceBar/index.vue'

import { ref, shallowRef, computed, provide } from 'vue'

import getOpt from './js/chartOpt.js'
import { unwarp } from '@/utils/tools.js'

import { unref } from 'vue'

export default {
  //import引入的组件需要注入到对象中才能使用
  components: { Warn1, Warn2, Warn3, Warn1Tiny, deviceBar },
  inject: ['getEventData'],
  props: ['dutyType'],
  data() {
    //这里存放数据
    return {
      pageInfo: 'index_upgrade.vue',
      computedName: '闭环管理弹框组件',
      imgH: bmeConfig.INIT_HEIGHT * 0.6,
      imgW: bmeConfig.INIT_WIDTH * 0.5,
      showDetailType: 0,
      customerId: this.$store.state.customerId,
      fadeInTimer: {},
      fadeOutTimer: {},

      pathName: null,

      cacheList: [
        {
          tipID: 'playTip-0',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          data: {}
        },
        {
          tipID: 'playTip-1',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          data: {}
        },
        {
          tipID: 'playTip-2',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          data: {}
        },
        {
          tipID: 'playTip-3',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          data: {}
        }
      ],
      cachePointList: [
        {
          tipID: 'playPos-0',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          renderTime: 0
        },
        {
          tipID: 'playPos-1',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          renderTime: 0
        },
        {
          tipID: 'playPos-2',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          renderTime: 0
        },
        {
          tipID: 'playPos-3',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          renderTime: 0
        },
        {
          tipID: 'playPos-4',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          renderTime: 0
        },
        {
          tipID: 'playPos-5',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          renderTime: 0
        }
      ],
      playList: [],
      pointList: [],
      winPos: [], //排放源点的定位
      isStop: false,
      //stopTime: 0,
      stopIndex: '',
      countIndex: 0,
      detailData: {},
      detailID: '',
      otherTimer: '',
      valueHistory: [],
      needDetail: false,
      counter: 0,
      treatType: false,

      singlePlayTimer: '',
      //dutyTimer: [],
      //dutyPointTimer: [],

      isLoad: false,
      loadStr: '拼命加载中',
      autoHeight: 595,
      sourceData: [],
      warnIdx: '',
      dutyInventoryId: '',
      dutyInventoryName: '',
      deviceStatus: false,

      restoreWarnTimer: null,

      lastRenderPlayTime: '',
      preventStopTimer: '',
      getDataTimer: '',

      traceSource: false,
      dustRate: 1,
      dustTimer: null,
      dustStatus: false,

      curDutyType: null,
      inUpgrade: true,

      mapType: null,

      pm10valueHistory: '',
      pm10Chart: '',

      vdmValueHistory: '',
      vdmChart: '',
      isArcgis: false,

      styleType: 'dark',

      eventReason: null,
      eventMeasure: null,

      dutyStore: [],
      historyDutyStore: [],
      baseOffSet: 0,
      hasChartData: false
    }
  },
  //计算属性 类似于data概念
  computed: {
    ...mapState({ prew: 'scaleValue' }),
    getHeaderCellClass() {
      return function (obj) {
        if (obj.columnIndex === 0) {
          return 'thClass_'
        } else {
          return 'thClass'
        }
      }
    },

    getHeadRowClass() {
      return function (obj) {
        return 'headTrClass'
      }
    },

    getCellClass() {
      return function (obj) {
        if (obj.columnIndex === 0) {
          return 'tdClass_'
        } else {
          return 'tdClass'
        }
      }
    },

    getRowClass() {
      return function (obj) {
        return 'trClass'
      }
    },

    getDustCurStyle() {
      return function (n) {
        if (
          this.winPos[this.cacheList.length + this.cachePointList.length + 1] &&
          this.winPos[this.cacheList.length + this.cachePointList.length + 1][0] &&
          this.winPos[this.cacheList.length + this.cachePointList.length + 1][3]
        ) {
          let l = this.winPos[this.cacheList.length + this.cachePointList.length + 1][0] / this.prew - 25
          let b = this.winPos[this.cacheList.length + this.cachePointList.length + 1][3] / this.prew - 25
          return {
            left: l + 'px',
            bottom: b + 'px',
            position: 'absolute'
          }
        } else {
          return {
            left: '0px',
            bottom: '0px',
            position: 'absolute'
          }
        }
      }
    }
  },
  //监控data中的数据变化
  watch: {
    '$route.name': {
      handler(newVal, oldVal) {
        this.pathName = newVal
        if (newVal != 'DutyMod') {
          this.$isStop.status = true
          this.stopIndex = -1
          this.dataReset()
          // this.timeoutClear();
        }
      },
      deep: true
    },
    dutyType: {
      handler(newVal, oldVal) {
        let that = this
        that.curDutyType = newVal
      }
    },
    getEventData: {
      handler(newVal, oldVal) {
        console.log('newVal:', newVal)
        let that = this
        let tmpObj = unref(newVal)
        let workTicketNo = tmpObj['workTicketNo']
        if (this.singlePlayTimer) {
          clearTimeout(this.singlePlayTimer)
        }
        this.singlePlayTimer = setTimeout(function () {
          that.getSinglePlayEvent(workTicketNo)
        }, 50)
      },
      deep: true
    }
  },
  provide: function () {
    return {
      getDutyInventoryId: computed(() => this.dutyInventoryId),
      updateDutyInventoryId: this.updateDutyInventoryId,

      getDutyInventoryName: computed(() => this.dutyInventoryName),
      updateDutyInventoryName: this.updateDutyInventoryName,

      getWarnSourceData: computed(() => this.sourceData),
      updateWarnSourceData: this.updateWarnSourceData,

      rowClickRecover: this.rowClickRecover
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  beforeMount() {
    this.curDutyType = this.dutyType
    this.pathName = 'DutyMod'
  },
  created() {
    //this.$XbsjBase = new XE.Core.XbsjBase();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this
    this.dataReset()

    this.mapType = bmeConfig.mapType

    this.styleType = bmeConfig.styleType

    this.isArcgis = bmeConfig.mapType === 'unity3D' ? false : true

    if (this.customerId == 35 || bmeConfig.spreadStatus) {
      this.traceSource = true
      this.dustStatus = true
    }

    if (bmeConfig.styleType == 'typeBlue') {
      // 处理typeBlue版本排放源点显示不正确
      //if (this.customerId == 77 || this.customerId == 78 || this.customerId == 74) {
      //  this.baseOffSet =
      //  document.getElementById('earthContainer') && Number(document.getElementById('earthContainer').style.left.replace('px', ''))
      //}
      this.baseOffSet =
        document.getElementById('earthContainer') && Number(document.getElementById('earthContainer').style.left.replace('px', ''))
    }

    $('.emission_table').hide()
    this.altitude = bmeConfig.altitude || bmeConfig.altitude === 0 ? bmeConfig.altitude : 50
    this.flyAltitude = this.altitude < 350 ? 350 : this.altitude

    //this.tipList();
    let total = this.cacheList.length + this.cachePointList.length + 2
    for (let i = 0; i < total; i++) {
      this.winPos.push([])
    }
    for (let i = 0; i < this.cacheList.length; i++) {
      this.$dutyTimer.push({})
    }
    for (let i = 0; i < this.cachePointList.length; i++) {
      this.$dutyPointTimer.push({})
    }

    this.timeoutClear()
    let startHH = new Date()
    console.log('startHH', startHH)
    this.flyToFixedPoint(function () {
      //that.getData();
      let halfway = new Date()
      console.log('halfway', halfway)

      that.renderPlay()
      that.preventStop()
      let endTime = new Date()
      console.log('endTime', endTime)
      // 这个过程10秒
    })

    $(this.$refs.test).unbind('click')
    $(this.$refs.test).bind('click', function () {
      that.closeDiv()
    })
  },
  // activated() {
  // let that = this;
  // this.dataReset();
  // let total = this.cacheList.length + this.cachePointList.length + 2;
  // for (let i = 0; i < total; i++) {
  //   this.winPos.push([]);
  // }
  // for (let i = 0; i < this.cacheList.length; i++) {
  //   this.$dutyTimer.push({});
  // }
  // for (let i = 0; i < this.cachePointList.length; i++) {
  //   this.$dutyPointTimer.push({});
  // }
  // // this.timeoutClear();
  // this.flyToFixedPoint(function () {
  //   //that.getData();
  //   that.renderPlay();
  //   that.preventStop();
  // });
  // $(this.$refs.test).unbind("click");
  // $(this.$refs.test).bind("click", function () {
  //   that.closeDiv();
  // });
  // }, //如果页面有keep-alive缓存功能，这个函数会触发
  unmounted() {
    this.$isStop.status = true
    this.stopIndex = -1
    this.dataReset()
    this.timeoutClear()
    if (this.lastRenderPlayTime) {
      clearTimeout(this.lastRenderPlayTime)
    }
    if (this.preventStopTimer) {
      clearTimeout(this.preventStopTimer)
    }
    if (this.getDataTimer) {
      clearTimeout(this.getDataTimer)
    }
  },
  beforeUnmount() {
    this.$isStop.status = true
    this.stopIndex = -1
    this.dataReset()
    this.timeoutClear()
    if (this.lastRenderPlayTime) {
      clearTimeout(this.lastRenderPlayTime)
    }
    if (this.preventStopTimer) {
      clearTimeout(this.preventStopTimer)
    }
    if (this.getDataTimer) {
      clearTimeout(this.getDataTimer)
    }
    this.$XbsjBase && this.$XbsjBase.destroy()
    this.$XbsjBase = new this.$XbsjBaseClass()
  },
  //方法集合
  methods: {
    preventStop() {
      let that = this
      if (this.$route.name !== 'DutyMod') {
        //that.$XbsjBase = that.$XbsjBase && that.$XbsjBase.destroy();
        /*const earth = window.g_bme3dManager.earth;
        let sceneList = earth.sceneTree.root.children;
        if (sceneList.length > 0) {
          for (let i = sceneList.length - 1; i >= 0; i--) {
            let ref = sceneList[i];
            if (
              (ref && ref.indexOf("playTip") >= 0) ||
              (ref && ref.indexOf("playPos") >= 0)
            ) {
              sceneList.splice(i, 1);
            }
          }
        }
        this.cacheList = [];
        this.cachePointList = [];
        this.winPos = [];*/
      } else {
        let nowTime = new Date().getTime()
        if (this.lastRenderPlayTime) {
          if (nowTime - this.lastRenderPlayTime > 60 * 1000) {
            this.stopIndex = -1
            this.$isStop.status = false
            this.renderPlay()
          }
        }
        if (this.preventStopTimer) {
          clearTimeout(this.preventStopTimer)
        }
        this.preventStopTimer = setTimeout(function () {
          that.preventStop()
        }, 1000)
      }
    },
    dataReset() {
      this.cacheList = [
        {
          tipID: 'playTip-0',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          data: {}
        },
        {
          tipID: 'playTip-1',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          data: {}
        },
        {
          tipID: 'playTip-2',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          data: {}
        },
        {
          tipID: 'playTip-3',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          data: {}
        }
      ]
      this.cachePointList = [
        {
          tipID: 'playPos-0',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          renderTime: 0
        },
        {
          tipID: 'playPos-1',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          renderTime: 0
        },
        {
          tipID: 'playPos-2',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          renderTime: 0
        },
        {
          tipID: 'playPos-3',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          renderTime: 0
        },
        {
          tipID: 'playPos-4',
          lng: 0,
          lat: 0,
          status: 'wait',
          type: 0,
          renderTime: 0
        }
      ]
      this.playList = []
      this.pointList = []
      this.winPos = [] //排放源点的定位
      this.$isStop.status = false
      this.stopTime = 0
      this.stopIndex = ''
      this.countIndex = 0
      this.deviceStatus = false
    },
    //初始飞行
    flyToFixedPoint(cb) {
      // console.log("fly-------------------------to");
      // if (!this.inUpgrade) return;
      let that = this
      if (that.flyToFixedTimer) {
        clearTimeout(this.flyToFixedTimer)
      }
      if (
        true
        /*window.g_bme3dManager &&
        window.g_bme3dManager.earth &&
        window.g_bme3dManager.earth.camera*/
      ) {
        let view = mapViews[`mapViews_${that.customerId}`] && mapViews[`mapViews_${that.customerId}`].dutyMod
        if (view && view.length) {
          //debugger;
          try {
            window.g_bme3dManager.earth.camera.flyTo(view[0], view[1], view[2], view[3])
          } catch (err) {
            console.log(err)
          }

          if (that.flyToFixedTimer) {
            clearTimeout(this.flyToFixedTimer)
          }
          that.flyToFixedTimer = setTimeout(function () {
            if (cb) {
              cb()
            }
          }, 4000)
        } else {
          if (that.flyToFixedTimer) {
            clearTimeout(this.flyToFixedTimer)
          }
          that.flyToFixedTimer = setTimeout(function () {
            if (cb) {
              cb()
            }
          }, 4000)
        }
      } else {
      }
    },
    openDiv() {
      let that = this
      let randomNum = Math.ceil(Math.random() * 2)
      this.showDetailType = randomNum
      setTimeout(function () {
        $(that.$refs.modal12).fadeIn(1000, function () {
          $(that.$refs.test).addClass('pointerEventAll')
        })
      }, 500)
    },
    closeDiv() {
      let that = this
      $(this.$refs.modal12).fadeOut(500, function () {
        $(that.$refs.test).removeClass('pointerEventAll')
      })
    },
    stopWarning(n) {
      this.$isStop.status = true
      this.stopTime = new Date().getTime()
      if (!n) {
        this.stopIndex = this.warnIdx
      } else {
        this.stopIndex = n
      }
      //this.timeoutClear();
    },
    restoreWarning(n) {
      if (this.deviceStatus) {
        return
      }
      let that = this
      if (this.restoreWarnTimer) {
        clearTimeout(this.restoreWarnTimer)
      }
      this.restoreWarnTimer = setTimeout(function () {
        that.stopIndex = -1
        that.$isStop.status = false
        that.timeoutClear()
        if ($('.emission_table').length > 0) {
          $('.emission_table').fadeOut(50)
        }
        that.renderPlay()
      }, 2000)
    },
    timeoutClear() {
      if (this.restoreWarnTimer) {
        clearTimeout(this.restoreWarnTimer)
      }
      if (this.dustTimer) {
        clearTimeout(this.dustTimer)
      }
      this.dustStatus = false
      if ($('.dustRotate').length > 0 && $('.dustRotate').stop) {
        $('.dustRotate').stop(true, true)
        if ($('.DustTip').length > 0) {
          $('.DustTip').hide()
        }
        $('.dustRotate').hide()
        $('.dustReason').hide()
      }
      for (let i = 0; i < this.$dutyTimer.length; i++) {
        for (let j in this.$dutyTimer[i]) {
          if (this.$dutyTimer[i][j]) {
            clearTimeout(this.$dutyTimer[i][j])
          }
        }
      }
      for (let i = 0; i < this.$dutyPointTimer.length; i++) {
        for (let j in this.$dutyPointTimer[i]) {
          if (this.$dutyPointTimer[i][j]) {
            clearTimeout(this.$dutyPointTimer[i][j])
          }
        }
      }

      this.cacheList.forEach(item => {
        item.status = 'wait'
      })

      if ($('.emission_table').length > 0) {
        $('.emission_table').fadeOut(50)
      }
    },
    //点击详情
    async getSinglePlayEvent(workTicketNo) {
      let that = this
      this.$isStop.status = true
      this.stopIndex = -1
      this.timeoutClear()
      this.eventReason = null
      this.eventMeasure = null
      let unionDetailUrl = CONFIG.requestName + this.$apiOpt.unionDetail
      let data = await this.$apiUtils.get(unionDetailUrl, {
        workTicketNo: workTicketNo
      })
      ;[data].forEach((_, i) => {
        let devicePos = {}
        _.isHistory = true

        that.eventReason = _.reason
        that.eventMeasure = _.measure

        that.getDevicePos(_.deviceNo, _.warnType).then(res => {
          devicePos = res
          console.log('devicePos', devicePos)
          let obj = {
            type: _.handleState == 2 || _.handleState == 3 ? 1 : 0,
            lng: devicePos.longitude || 0,
            lat: devicePos.latitude || 0,
            height: bmeConfig.altitude,
            data: _,
            typeId: _.typeId,
            isHistory: true
          }
          if (bmeConfig.spreadStatus) {
            this.getFindSpread(_.deviceNo)
              .then(res => {
                let spreadObj = res
                if (
                  spreadObj &&
                  spreadObj.length > 0 &&
                  Object.prototype.toString.call(spreadObj[0]) === '[object Object]' &&
                  /*spreadObj[0]["longitude"] &&
                spreadObj[0]["latitude"] &&*/
                  devicePos.longitude &&
                  devicePos.latitude &&
                  spreadObj[0]['predict_lon'] &&
                  spreadObj[0]['predict_lat']
                ) {
                  obj.spreadLng = devicePos.longitude //spreadObj[0]["longitude"];
                  obj.spreadLat = devicePos.latitude //spreadObj[0]["latitude"];
                  obj.spreadPredictLng = spreadObj[0]['predict_lon']
                  obj.spreadPredictLat = spreadObj[0]['predict_lat']
                } /*else {
                console.log(spreadObj[0]);
                obj.spreadLng = obj["lng"];
                obj.spreadLat = obj["lat"];
                obj.spreadPredictLng =
                  obj["lng"] + 0.005 * (Math.random() - 1) * 2;
                obj.spreadPredictLat =
                  obj["lat"] + 0.005 * (Math.random() - 1) * 2;
              }*/
                that.playList.unshift(obj)

                for (let j in that.cacheList) {
                  if (that.cacheList[j]['status'] == 'play') {
                    $('#' + that.cacheList[j]['tipID']).fadeOut(50, function () {
                      that.cacheList[j]['status'] = 'wait'
                    })
                  }
                }
                //that.stopIndex = -1;
                that.$isStop.status = false
                that.renderPlay(true)
              })
              .catch(err => {
                console.log(err)
                that.playList.unshift(obj)

                //that.stopIndex = -1;
                that.$isStop.status = false
                that.renderPlay(true)
              })
          } else {
            console.log('obj111', obj)
            that.playList.unshift(obj)

            //that.stopIndex = -1;
            that.$isStop.status = false
            that.renderPlay(true)
          }

          //that.flyToFixedPoint();
        })
      })
    },
    checkStore(list) {
      this.dutyStore = []
      list.forEach(item => {
        if (
          $.inArray(item.workTicketNo, this.historyDutyStore) < 0 /*&&
          item.warnType ==
            1 */ /*&&
          (item.handleState === 0 || item.handleState === 1)*/
        ) {
          this.dutyStore.push(item.workTicketNo)
          this.historyDutyStore.push(item.workTicketNo)
        }
      })

      console.log(this.dutyStore)
      if (this.dutyStore.length > 0) {
        //this.$message.close();
        this.$message({
          type: 'info',
          message: '当前有' + this.dutyStore.length + '条超标告警等待处理!',
          duration: 15000,
          showClose: true
        })
      }
    },
    async getPlayEvents() {
      // if (!this.inUpgrade) return;
      let scroll = CONFIG.requestName + this.$apiOpt.scroll
      let data = await this.$apiUtils.get(scroll, {
        customerId: this.customerId
      })
      //this.checkStore(data);
      let upgradeList = []
      data.forEach(item => {
        if (this.customerId == 14 && item.typeName && (item.typeName.indexOf('CEMS') >= 0 || item.typeName.indexOf('TSP') >= 0)) {
          upgradeList.push(item)
        } else {
          upgradeList.push(item)
        }
      })
      if (upgradeList.length === 0) {
        this.getData()
      } else {
        upgradeList.forEach((_, i) => {
          //console.log("12111111", _);
          let devicePos = {}
          //let spreadObj = await this.getFindSpread(_.deviceNo);
          this.getDevicePos(_.deviceNo, _.warnType).then(res => {
            //console.log("获取经纬度", res);
            devicePos = res
            let obj = {
              type: _.handleState == 2 || _.handleState == 3 ? 1 : 0,
              lng: devicePos.longitude || 0,
              lat: devicePos.latitude || 0,
              height: bmeConfig.altitude,
              data: _,
              typeId: _.typeId
            }
            if (bmeConfig.spreadStatus) {
              this.getFindSpread(_.deviceNo)
                .then(res => {
                  let spreadObj = res
                  if (
                    spreadObj &&
                    spreadObj.length > 0 &&
                    Object.prototype.toString.call(spreadObj[0]) === '[object Object]' &&
                    /*spreadObj[0]["longitude"] &&
                  spreadObj[0]["latitude"] &&*/
                    devicePos.longitude &&
                    devicePos.latitude &&
                    spreadObj[0]['predict_lon'] &&
                    spreadObj[0]['predict_lat']
                  ) {
                    obj.spreadLng = devicePos.longitude //spreadObj[0]["longitude"];
                    obj.spreadLat = devicePos.latitude //spreadObj[0]["latitude"];
                    obj.spreadPredictLng = spreadObj[0]['predict_lon']
                    obj.spreadPredictLat = spreadObj[0]['predict_lat']
                  } /*else {
                  console.log(spreadObj[0]);
                  obj.spreadLng = obj["lng"];
                  obj.spreadLat = obj["lat"];
                  obj.spreadPredictLng =
                    obj["lng"] + 0.005 * (Math.random() - 1) * 2;
                  obj.spreadPredictLat =
                    obj["lat"] + 0.005 * (Math.random() - 1) * 2;
                  // console.log(spreadObj[0]);
                }*/
                  this.playList.push(obj)
                })
                .catch(err => {
                  // console.log(err);
                  this.playList.push(obj)
                })
            } else {
              this.playList.push(obj)
            }
          })
        })
        this.renderPlay()
      }
    },
    getPointEvents() {
      let typeIndex = Math.floor(Math.random() * 2)
      let obj = {
        type: typeIndex,
        lng: 118.5526416 + Math.random() * 2 * 0.01,
        lat: 39.9679961 + Math.random() * 2 * 0.01,
        height: bmeConfig.altitude
      }
      if (this.pointList.length > 10) {
        this.pointList.push(obj)
      }
    },

    //循环加数据
    getData() {
      let that = this
      let readyTime = 1000
      if (this.customerId == 50) {
        readyTime = 5000
      }
      if (that.getDataTimer) {
        clearTimeout(that.getDataTimer)
      }
      that.getDataTimer = setTimeout(function () {
        that.getPlayEvents()
      }, readyTime)

      // that.getPointEvents();
      /*if (this.getDataTimer) {
        clearTimeout(this.getDataTimer);
      }
      this.getDataTimer = setTimeout(function () {
        that.getData();
      }, 120000);*/
    },
    updateWarnSourceData(sourceData) {
      this.sourceData = sourceData
    },
    //画点
    drawPointTip(tipID, lng, lat, height, n, earth, warnType) {
      let that = this
      let pin = window.earth ? earth.sceneTree.$refs[tipID] : ''
      if (warnType === 0 || warnType === 1) {
        that.cachePointList[n]['type'] = 0
      } else {
        that.cachePointList[n]['type'] = 1
      }
      if (pin) {
        let pos = '[' + lng + '*Math.PI/180.0, ' + lat + '*Math.PI/180.0,' + height + ']'
        let pos1 = eval(pos)
        let pinCzm = pin.czmObject
        pinCzm.position = pos1
        let n_ = n + that.cacheList.length

        that.$XbsjBase.disposers.push(XE.MVVM.track(this, 'winPos.' + n_, pinCzm, 'winPos'))

        //XE.MVVM.track(this, "winPos." + n_, pinCzm, "winPos");
      } else {
        let pos = '[' + lng + '*Math.PI/180.0, ' + lat + '*Math.PI/180.0,' + height + ']'
        let pos1 = eval(pos)
        var tipListObj = {
          ref: tipID,
          czmObject: {
            name: tipID,
            xbsjType: 'Pin',
            position: pos1,
            near: 300,
            show: false
          }
        }
        if (earth && earth.sceneTree) {
          earth.sceneTree.root.children.push(tipListObj)
          let pinCzm = earth.sceneTree.$refs[tipID].czmObject
          let n_ = n + that.cacheList.length

          that.$XbsjBase.disposers.push(XE.MVVM.track(this, 'winPos.' + n_, pinCzm, 'winPos'))
        }

        //XE.MVVM.track(this, "winPos." + n_, pinCzm, "winPos");
      }
      this.$forceUpdate()
    },
    getDustPos(earth, height, lng, lat, lng_, lat_, curRate) {
      this.dustStatus = true
      let that = this
      let frequency = 1000
      curRate = curRate ? curRate : 1
      let tipID = 'dustTip-0'
      let pin = window.earth ? earth.sceneTree.$refs[tipID] : ''
      let pinCzm

      let tipID_ = 'dustTip-1'
      let pin_ = window.earth ? earth.sceneTree.$refs[tipID_] : ''
      let pinCzm_
      if (pin) {
        let pos = '[' + lng + '*Math.PI/180.0, ' + lat + '*Math.PI/180.0,' + height + ']'
        let pos1 = eval(pos)
        pinCzm = pin.czmObject
        pinCzm.position = pos1
        that.$XbsjBase.disposers.push(
          XE.MVVM.track(that, 'winPos.' + (that.cacheList.length + that.cachePointList.length + 1), pinCzm, 'winPos')
        )
        /*XE.MVVM.track(
          that,
          "winPos." + (that.cacheList.length + that.cachePointList.length + 1),
          pinCzm,
          "winPos"
        );*/

        let pos_ = '[' + lng_ + '*Math.PI/180.0, ' + lat_ + '*Math.PI/180.0,' + height + ']'
        let pos1_ = eval(pos_)
        pinCzm_ = pin_.czmObject
        pinCzm_.position = pos1_
        that.$XbsjBase.disposers.push(
          XE.MVVM.track(that, 'winPos.' + (that.cacheList.length + that.cachePointList.length + 2), pinCzm_, 'winPos')
        )
        /*XE.MVVM.track(
          that,
          "winPos." + (that.cacheList.length + that.cachePointList.length + 2),
          pinCzm_,
          "winPos"
        );*/
        //console.log("pinCzm", pinCzm);
      } else {
        let pos = '[' + lng + '*Math.PI/180.0, ' + lat + '*Math.PI/180.0,' + height + ']'
        let pos1 = eval(pos)
        var tipListObj = {
          ref: tipID,
          czmObject: {
            name: tipID,
            xbsjType: 'Pin',
            position: pos1,
            near: 300,
            show: false
          }
        }
        if (earth && earth.sceneTree) {
          earth.sceneTree.root.children.push(tipListObj)
          pinCzm = earth.sceneTree.$refs[tipID].czmObject
          that.$XbsjBase.disposers.push(
            XE.MVVM.track(that, 'winPos.' + (that.cacheList.length + that.cachePointList.length + 1), pinCzm, 'winPos')
          )
        }
        /*XE.MVVM.track(
          that,
          "winPos." + (that.cacheList.length + that.cachePointList.length + 1),
          pinCzm,
          "winPos"
        );*/

        let pos_ = '[' + lng_ + '*Math.PI/180.0, ' + lat_ + '*Math.PI/180.0,' + height + ']'
        let pos1_ = eval(pos_)
        var tipListObj_ = {
          ref: tipID_,
          czmObject: {
            name: tipID_,
            xbsjType: 'Pin',
            position: pos1_,
            near: 300,
            show: false
          }
        }
        if (earth && earth.sceneTree) {
          earth.sceneTree.root.children.push(tipListObj_)
          pinCzm_ = earth.sceneTree.$refs[tipID_].czmObject
          that.$XbsjBase.disposers.push(
            XE.MVVM.track(that, 'winPos.' + (that.cacheList.length + that.cachePointList.length + 2), pinCzm_, 'winPos')
          )
        }
        /*XE.MVVM.track(
          that,
          "winPos." + (that.cacheList.length + that.cachePointList.length + 2),
          pinCzm_,
          "winPos"
        );*/
      }

      this.$forceUpdate()
      this.$nextTick(() => {
        if ($('.DustTip').length > 0) {
          let protoObj = that.winPos[that.cacheList.length + that.cachePointList.length + 1]
          let predictObj = that.winPos[that.cacheList.length + that.cachePointList.length + 2]
          $('.DustTip')
            .css('left', protoObj[0] / this.prew - 25)
            .css('bottom', protoObj[3] / this.prew - 25)
          $('.dustRotate').css('transform', 'scale(1)').css('left', '0px').css('bottom', '0px').css('textIndent', 0).show()
          $('.dustReason').show()
          $('.DustTip').show()
          let deltaX = predictObj[0] - protoObj[0]
          let deltaY = predictObj[3] - protoObj[3]
          let xyRate = deltaX / deltaY

          $('.dustRotate')
            .attr('leftVal', deltaX)
            .attr('bottomVal', deltaY)
            .delay(3000)
            .animate(
              { textIndent: 200 }, //textIndent的值便是now的終值
              {
                step: function (now, fx) {
                  let deltaX = parseInt($(this).attr('leftVal'))
                  let deltaY = parseInt($(this).attr('bottomVal'))
                  $(this).addClass('dustAnimate')
                  $(this)
                    .css('transform', 'scale(' + (1 + Math.abs(Math.abs(100 - (now < 150 ? now : 150)) - 100) / 10) + ')')
                    .css('transformOrigin', 'center center')
                    .css('left', (deltaX * (now < 150 ? now : 150)) / 150)
                    .css('bottom', (deltaY * (now < 150 ? now : 150)) / 150)
                  if (now === 200) {
                    that.dustStatus = false
                  }
                },
                duration: 20000
              },
              'linear'
            )
        }
      })
    },
    //画弹窗
    async drawTip(tipID, workTicketNo, lng, lat, height, n, earth, infoObj, idx) {
      // if (!this.inUpgrade) return;
      let that = this
      if (that.$isStop.status || that.stopIndex === n) {
        return
      }
      let pin = window.earth ? earth.sceneTree.$refs[tipID] : ''
      let tmpNode = $('#' + tipID)
      tmpNode.fadeOut(0)

      try {
        if (lng && lat) {
          // by 刘阳洋 有些设备无坐标
          let flyArg = window.g_bme3dManager ? JSON.parse(g_bme3dManager.earth.camera.toAllJSONStr()) : {}

          let earth = window.g_bme3dManager ? window.g_bme3dManager.earth : ''

          /*window.earth &&
            earth.camera.flyTo(
              [(lng * Math.PI) / 180.0, (lat * Math.PI) / 180.0, that.altitude + 50],
              that.flyAltitude + 2500,
              flyArg.rotation,
              0.5
            );*/

          if (that.$dutyTimer[n]['fly_1']) {
            clearTimeout(that.$dutyTimer[n]['fly_1'])
          }
          that.$dutyTimer[n]['fly_1'] = setTimeout(function () {
            if (that.$isStop.status || that.stopIndex === n) {
              return
            }
            let flyMultiple = that.flyAltitude + (bmeConfig.nearByDistance ? bmeConfig.nearByDistance : 350)
            if (that.customerId == 74) {
              flyMultiple = 200
            }
            earth &&
              earth.camera.flyTo(
                [(lng * Math.PI) / 180.0, (lat * Math.PI) / 180.0, that.altitude + 50],
                flyMultiple,
                flyArg.rotation,
                idx === 0 ? 0.5 : that.needDetail ? 1 : 1.4
              )
            // console.log(flyObj);
          }, 1000)
        }
      } catch (err) {
        console.log(err)
      }
      //去掉随机状态
      // that.cacheList[n]["type"] = Math.floor(Math.random() * 4);

      //debugger;
      let upgradeList = await that.getUpgrade(workTicketNo)
      upgradeList = upgradeList.sort(function (a, b) {
        return b['level'] - a['level']
      })
      infoObj.data.upgradeList = upgradeList && upgradeList.length > 0 ? upgradeList : []
      infoObj.data.upgradeList.forEach((item, n) => {
        if (item.state === 1 && !infoObj.data.curIdex) {
          infoObj.data.curIdex = n
        } else {
          infoObj.data.curIdex = 0
        }
      })

      //let sourceData = await this.getUpgradeTable("202106171141034981469391641");
      that.sourceData = []
      let sourceData = await that.getUpgradeTable(workTicketNo)
      //that.sourceData = sourceData && sourceData.length > 0 ? sourceData : [];
      //infoObj.data.sourceData = sourceData && sourceData.length > 0 ? sourceData : [];
      //debugger;
      // console.log(sourceData);
      //靠近飞越
      let sb = new Date()
      console.log(sourceData, sb, 'sb')

      if (this.$dutyTimer[n]['renderData']) {
        clearTimeout(this.$dutyTimer[n]['renderData'])
      }
      this.$dutyTimer[n]['renderData'] = setTimeout(
        function () {
          if (that.$isStop.status || that.stopIndex === n) {
            return
          }
          let pinCzm
          if (pin) {
            let pos = '[' + lng + '*Math.PI/180.0, ' + lat + '*Math.PI/180.0,' + height + ']'
            let pos1 = eval(pos)
            pinCzm = pin.czmObject
            pinCzm.position = pos1

            that.$XbsjBase.disposers.push(XE.MVVM.track(that, 'winPos.' + n, pinCzm, 'winPos'))

            //XE.MVVM.track(that, "winPos." + n, pinCzm, "winPos");
          } else {
            let pos = '[' + lng + '*Math.PI/180.0, ' + lat + '*Math.PI/180.0,' + height + ']'
            let pos1 = eval(pos)
            var tipListObj = {
              ref: tipID,
              czmObject: {
                name: tipID,
                xbsjType: 'Pin',
                position: pos1,
                near: 300,
                show: false
              }
            }
            if (earth) {
              earth.sceneTree.root.children.push(tipListObj)
              pinCzm = earth.sceneTree.$refs[tipID].czmObject
              that.$XbsjBase.disposers.push(XE.MVVM.track(that, 'winPos.' + n, pinCzm, 'winPos'))
            }
            //XE.MVVM.track(that, "winPos." + n, pinCzm, "winPos");
          }

          that.$forceUpdate()
          that.$nextTick(function () {
            let tmpNode = $('#' + tipID)
            let compontentBar = tmpNode.find('.warn_block').find('.popupBar')

            if (
              (that.traceSource &&
                /*infoObj.spreadLng &&
              infoObj.spreadLat &&*/
                lng,
              lat,
              infoObj.spreadPredictLng && infoObj.spreadPredictLat)
            ) {
              if (this.dustTimer) {
                clearTimeout(this.dustTimer)
              }
              that.getDustPos(
                earth,
                height,
                /*infoObj.spreadLng,
                infoObj.spreadLat,*/
                lng,
                lat,
                infoObj.spreadPredictLng,
                infoObj.spreadPredictLat,
                ''
              )
            }
            //tmpNode.fadeOut(0);
            let isLeft = false,
              isTop = false

            let ltPos = that.getOffsetTLByBody(tmpNode.get(0))
            let innerPos = that.getOffsetTLByBody(compontentBar.get(0))
            let l = pinCzm ? pinCzm._winPos[0] / this.prew : $('.components_container').outerWidth() / 2
            let b = pinCzm ? pinCzm._winPos[3] / this.prew : 0

            let screenW = $('.components_container').outerWidth()
            let screenH = $('.components_container').outerHeight()
            tmpNode.removeClass('bottomLeft')
            tmpNode.removeClass('bottomRight')

            // console.log("=================================");
            // console.log(l, b);
            // console.log(this.prew, parseFloat(bmeConfig.scaleRate));
            // console.log(screenW, screenH);
            //if (l > screenW / 2) {
            if (that.countIndex % 2 === 0) {
              that.countIndex++
              //if (that.countIndex % 2 === 0) {
              //tmpNode.find(".warn_innerBlock").css("left", -tmpNode.outerWidth());
              //tmpNode.find(".warn_innerBlock").css("left", screenW * 0.2);
              tmpNode.find('.warn_innerBlock').css('transformOrigin', 'left bottom')
              tmpNode
                .find('.warn_innerBlock')
                .css('left', l - 30 - (this.styleType === 'typeBlue' ? 150 : 0))
                .css('bottom', b)
              tmpNode.find('.warn_innerBlock').css('transform', 'scale(0.1, 0.1) translate(0px, 0px) rotateY(90deg)')

              tmpNode.find('.upgrade').hide()
              $('.emission_table').css('top', 150).css('right', 'initial').css('left', 700).hide()
              isLeft = false
            } else {
              that.countIndex++
              //tmpNode.find(".warn_innerBlock").css("left", tmpNode.outerWidth());
              /*tmpNode
            .find(".warn_innerBlock")
            .css("left", screenW * 0.8 - tmpNode.outerWidth());*/
              //tmpNode.find(".warn_innerBlock").css("left", l).css("bottom", b);
              tmpNode.find('.warn_innerBlock').css('transformOrigin', 'left bottom')
              tmpNode
                .find('.warn_innerBlock')
                .css('left', l - 30 + (this.styleType === 'typeBlue' ? 150 : 0))
                .css('bottom', b)
              $('.emission_table').css('top', 150).css('left', 'initial').css('right', 700).hide()
              tmpNode.find('.warn_innerBlock').css('transform', 'scale(0.1, 0.1) translate(0px, 0px) rotateY(-90deg)')

              tmpNode.find('.upgrade').css('marginLeft', '460px').hide()
              isLeft = true
            }

            tmpNode.fadeOut(0)

            /*if (this.$dutyTimer[n]["fadeIn"]) {
          clearTimeout(this.$dutyTimer[n]["fadeIn"]);
          if (this.$dutyTimer[n]["fadeOut"]) {
            clearTimeout(this.$dutyTimer[n]["fadeOut"]);
            this.$isStop.status = false;
          }
        }*/

            if (this.$dutyTimer[n]['fadeIn']) {
              clearTimeout(this.$dutyTimer[n]['fadeIn'])
            }
            this.$dutyTimer[n]['fadeIn'] = setTimeout(function () {
              tmpNode.fadeIn(2000, function () {
                if (that.$isStop.status || that.stopIndex === n) {
                  return
                }

                //工单升级

                //that.sourceData = sourceData.list;
                if (that.curDutyType === 'upgrade') {
                  that.updateWarnSourceData(sourceData.list)
                  that.$forceUpdate()
                  that.$nextTick(function () {
                    if (that.$isStop.status || that.stopIndex === n) {
                      return
                    }
                    if (that.sourceData.length > 0) {
                      $('.emission_table').fadeIn(1000)
                    }
                  })
                  tmpNode.find('.upgrade').fadeIn(1000, function () {
                    // debugger;
                  })
                }

                if (that.$dutyTimer[n]['fadeOut']) {
                  clearTimeout(that.$dutyTimer[n]['fadeOut'])
                }
                that.$dutyTimer[n]['fadeOut'] = setTimeout(
                  function () {
                    if (that.$isStop.status || that.stopIndex === n) {
                      return
                    }
                    //镜头移近
                    if (that.needDetail) {
                      tmpNode.fadeOut(1400)
                      $('.emission_table').fadeOut(1000)

                      if (that.$dutyTimer[n]['fadeOut']) {
                        clearTimeout(that.$dutyTimer[n]['fadeOut'])
                      }
                      that.$dutyTimer[n]['fadeOut'] = setTimeout(function () {
                        that.cacheList[n]['status'] = 'wait'
                        if (that.$isStop.status || that.stopIndex === n) {
                          return
                        }

                        that.renderPoint(lng, lat, earth, that.cacheList[n]['type'])
                        try {
                          let flyArg = JSON.parse(g_bme3dManager.earth.camera.toAllJSONStr())

                          const earth = window.g_bme3dManager.earth

                          if (that.$dutyTimer[n]['fly_2']) {
                            clearTimeout(that.$dutyTimer[n]['fly_2'])
                          }
                          that.$dutyTimer[n]['fly_2'] = setTimeout(function () {
                            if (that.$isStop.status || that.stopIndex === n) {
                              return
                            }
                            if (customerId != 57) {
                              if (!lng && !lat) {
                                console.log('bufeixing')
                              } else {
                                earth.camera.flyTo(
                                  [(lng * Math.PI) / 180.0, (lat * Math.PI) / 180.0, that.altitude + 50],
                                  that.flyAltitude + 2500,
                                  flyArg.rotation,
                                  1.4
                                )
                              }
                            }
                            // console.log(flyObj);
                          }, 50)

                          if (that.$dutyTimer[n]['fly_3']) {
                            clearTimeout(that.$dutyTimer[n]['fly_3'])
                          }
                          that.$dutyTimer[n]['fly_3'] = setTimeout(function () {
                            if (that.$isStop.status || that.stopIndex === n) {
                              return
                            }
                            if (lng && lat) {
                              earth.camera.flyTo(
                                [(lng * Math.PI) / 180.0, (lat * Math.PI) / 180.0, that.altitude + 50],
                                /*that.flyAltitude + 350,*/
                                that.flyAltitude + (bmeConfig.nearByDistance ? bmeConfig.nearByDistance : 350),
                                flyArg.rotation,
                                1.4
                              )
                            }
                            let screenW = $('.components_container').outerWidth()
                            let screenH = $('.components_container').outerHeight()
                            $(that.$refs.infoDetail).fadeOut(0)
                            $(that.$refs.infoDetail).css('top', screenH / 2 - 410 + 'px')
                            $(that.$refs.infoDetail).css('left', screenW / 2 - 430 / 2 + 'px')
                            $(that.$refs.infoDetail).find('.warn1-Tiny').removeClass('warn1-large')
                            $(that.$refs.infoHistory).fadeOut(0)
                            $(that.$refs.infoHistory).css('top', screenH / 2 - 410 + 500 + 'px')
                            $(that.$refs.infoHistory).css('left', screenW / 2 + 100 + 'px')
                            $(that.$refs.infoHistory).removeClass('infoHistory-large')
                            if (that.$dutyTimer[n]['detailIn']) {
                              clearTimeout(that.$dutyTimer[n]['detailIn'])
                            }
                            that.$dutyTimer[n]['detailIn'] = setTimeout(function () {
                              if (that.$isStop.status || that.stopIndex === n) {
                                return
                              }
                              $(that.$refs.infoHistory).fadeIn(1400)
                              $(that.$refs.infoDetail).fadeIn(1400)

                              if (that.$dutyTimer[n]['detailTransform']) {
                                clearTimeout(that.$dutyTimer[n]['detailTransform'])
                              }
                              that.$dutyTimer[n]['detailTransform'] = setTimeout(function () {
                                if (that.$isStop.status || that.stopIndex === n) {
                                  return
                                }
                                $(that.$refs.infoDetail).find('.warn1-Tiny').addClass('warn1-large')
                                $(that.$refs.infoHistory).addClass('infoHistory-large')

                                if (that.$dutyTimer[n]['detailOut']) {
                                  clearTimeout(that.$dutyTimer[n]['detailOut'])
                                }
                                that.$dutyTimer[n]['detailOut'] = setTimeout(function () {
                                  if (that.$isStop.status || that.stopIndex === n) {
                                    return
                                  }
                                  $(that.$refs.infoDetail).fadeOut(1000)
                                  $(that.$refs.infoHistory).fadeOut(1000)

                                  if (that.$dutyTimer[n]['rerender']) {
                                    clearTimeout(that.$dutyTimer[n]['rerender'])
                                  }
                                  that.$dutyTimer[n]['rerender'] = setTimeout(function () {
                                    if (that.$isStop.status || that.stopIndex === n) {
                                      return
                                    }
                                    //详情之后的结束
                                    that.renderPlay()
                                  }, 3000)
                                }, 5500)
                              }, 1000)
                              that.detailData = infoObj.data
                              if (that.detailData) {
                                if (that.detailData.handleState == 0 || that.detailData.handleState == 1) {
                                  that.treatType = false
                                } else if (that.detailData.handleState == 2) {
                                  that.treatType = false
                                } else if (that.detailData.handleState == 3) {
                                  that.treatType = true
                                } else {
                                  that.treatType = false
                                }
                              }
                              that.detailID = infoObj.typeId

                              if (infoObj.data.warnType == 5) {
                                if (infoObj.data.chartRoadPM10) that.pm10valueHistory = infoObj.data.chartRoadPM10
                                that.getRealityDataPM10()

                                if (infoObj.data.chartRoadVDM) {
                                  that.vdmValueHistory = infoObj.data.chartRoadVDM
                                  that.getRealityDataVDM()
                                }
                              } else {
                                that.valueHistory = infoObj.data.valueHistory
                                that.getRealityData()
                              }
                            }, 50)
                          }, 3500)
                        } catch (err) {
                          console.log(err)
                        }
                      }, 50)
                    } else {
                      // debugger;
                      //正常结束
                      $('.emission_table').fadeOut(1000)
                      tmpNode.fadeOut(2000, function () {
                        that.cacheList[n]['status'] = 'wait'
                        if (that.$isStop.status || that.stopIndex === n) {
                          return
                        }

                        that.renderPoint(lng, lat, earth, that.cacheList[n]['type'])

                        if (that.$dutyTimer[n]['rerender']) {
                          clearTimeout(that.$dutyTimer[n]['rerender'])
                        }
                        that.$dutyTimer[n]['rerender'] = setTimeout(function () {
                          if (that.$isStop.status || that.stopIndex === n) {
                            return
                          }
                          that.renderPlay()
                        }, 3000)

                        //that.$isStop.status = false;
                      })
                    }
                  },
                  this.curDutyType === 'upgrade' ? 25000 : 15000
                )
              })
              tmpNode.find('.warn_innerBlock').addClass(isLeft ? (isTop ? 'topLeft' : 'bottomLeft') : isTop ? 'topRight' : 'bottomRight')

              //debugger;
              if (isLeft) {
                tmpNode
                  .find('.warn_innerBlock')
                  .css(
                    'transform',
                    'scale(1, 1) translate(' + (bmeConfig.DIY_W * 2 + 100 - l) + 'px, ' + (b - screenH + 750 + 300) + 'px) rotateY(-360deg)'
                  )
              } else {
                tmpNode
                  .find('.warn_innerBlock')
                  .css(
                    'transform',
                    'scale(1, 1) translate(' +
                      (screenW - bmeConfig.DIY_W * 2 - l - 500) +
                      'px, ' +
                      (b - screenH + 750 + 300) +
                      'px) rotateY(360deg)'
                  )
              }
            }, 50 + 500)
          })
        },
        idx === 0 ? 100 : that.needDetail ? 1500 : 4000
      )
    },
    async getUpgrade(tipID) {
      let that = this
      return await new Promise((reslove, reject) => {
        let workTicketLevelManageListUrl = CONFIG.requestName + that.$apiOpt.workTicketLevelManageList
        that.$apiUtils
          .get(workTicketLevelManageListUrl, {
            customerId: that.$store.state.customerId,
            workTicketNo: tipID
          })
          .then(function (response) {
            reslove(response)
          })
          .catch(e => {
            console.log(e)
          })
      })
    },
    async getUpgradeTable(tipID) {
      let that = this
      return await new Promise((reslove, reject) => {
        let getEmissionSourceListUrl = CONFIG.requestName + that.$apiOpt.getEmissionSourceList
        that.$apiUtils
          .get(getEmissionSourceListUrl, {
            customerId: that.$store.state.customerId,
            workTicketNo: tipID,
            pageNo: 1,
            pageSize: 100
          })
          .then(function (response) {
            reslove(response)
          })
          .catch(e => {
            console.log(e)
          })
      })
    },
    getRealityData() {
      let _this = this
      let valueHistory = this.valueHistory
      if (valueHistory && valueHistory.length > 0 && valueHistory[0]['dps']) {
        this.hasChartData = true
        let dps = valueHistory[0]['dps']
        this.pmData = {
          xData: [],
          y1Data: [],
          y2Data: []
        }
        for (let i in dps) {
          this.noData = false
          this.pmData.xData.push(this.$moment(i * 1000).format('MM-DD hh:mm'))
          this.pmData.y1Data.push(dps[i] ? parseFloat(dps[i].toFixed(2)) : null)
          this.pmData.y2Data.push(0)
        }
        this.$nextTick(function () {
          if (!this.chart) {
            this.chart = echarts.init(this.$refs.chart)
          }
          let optionStr = getOpt(this.pmData, this.detailData.signalName)
          unwarp(this.chart).setOption(optionStr)
        })
      } else {
        this.hasChartData = false
      }
    },

    getRealityDataPM10() {
      let _this = this
      let valueHistory = this.pm10valueHistory
      if (valueHistory) {
        let dps = valueHistory
        this.pmData = {
          xData: [],
          y1Data: [],
          y2Data: []
        }
        for (let i in dps) {
          this.noData = false
          this.pmData.xData.push(this.$moment(i * 1000).format('MM-DD hh:mm'))
          this.pmData.y1Data.push(dps[i] ? parseFloat(dps[i].toFixed(2)) : null)
          this.pmData.y2Data.push(0)
        }
        this.$nextTick(function () {
          if (!this.pm10Chart) {
            this.pm10Chart = echarts.init(this.$refs.chart1)
          }
          let optionStr = getOpt(this.pmData, this.detailData.signalName)
          unwarp(this.pm10Chart).setOption(optionStr)
        })
      }
    },

    getRealityDataVDM() {
      let _this = this
      let valueHistory = this.vdmValueHistory
      if (valueHistory) {
        let dps = valueHistory
        this.pmData = {
          xData: [],
          y1Data: [],
          y2Data: []
        }
        for (let i in dps) {
          this.noData = false
          this.pmData.xData.push(this.$moment(i * 1000).format('MM-DD hh:mm'))
          this.pmData.y1Data.push(dps[i] ? parseFloat(dps[i].toFixed(2)) : null)
          this.pmData.y2Data.push(0)
        }
        this.$nextTick(function () {
          if (!this.vdmChart) {
            this.vdmChart = echarts.init(this.$refs.chart2)
          }
          let optionStr = getOpt(this.pmData, this.detailData.signalName)
          unwarp(this.vdmChart).setOption(optionStr)
        })
      }
    },

    getOffsetTLByBody(el) {
      let offsetTop = 0,
        offsetLeft = 0
      while (el && el.tagName !== 'BODY') {
        offsetTop += el.offsetTop
        offsetLeft += el.offsetLeft
        el = el.offsetParent
      }
      return {
        left: offsetLeft,
        top: offsetTop
      }
    },
    renderPoint(lng, lat, earth, warnType) {
      let that = this
      let checkPointIndex = that.checkCachePointAvailable()
      if (checkPointIndex >= 0) {
        let cachePointObj = that.cachePointList[checkPointIndex]
        cachePointObj['lng'] = lng
        cachePointObj['lat'] = lat
        cachePointObj['status'] = 'play'
        cachePointObj['renderTime'] = new Date().getTime()
        //$("#" + cacheObj["tipID"]).hide();
        that.drawPointTip(
          cachePointObj['tipID'],
          cachePointObj['lng'],
          cachePointObj['lat'],
          bmeConfig.altitude,
          checkPointIndex,
          earth,
          warnType
        )
      } else {
        this.cachePointList = this.cachePointList.sort(function (a, b) {
          return a['renderTime'] - b['renderTime']
        })
        let cachePointObj = that.cachePointList[0]
        cachePointObj['lng'] = lng
        cachePointObj['lat'] = lat
        cachePointObj['status'] = 'play'
        //$("#" + cacheObj["tipID"]).hide();
        that.drawPointTip(cachePointObj['tipID'], cachePointObj['lng'], cachePointObj['lat'], bmeConfig.altitude, 0, earth, warnType)
      }
    },
    renderPlay(isDetail) {
      if (this.$isStop.status && !isDetail) {
        return
      }
      this.lastRenderPlayTime = new Date().getTime()
      this.timeoutClear()
      if (this.playList.length === 0) {
        this.getData()
        return
      }
      let that = this
      that.counter++

      /*if (that.counter % 4 === 0) {
        that.needDetail = true;
      } else {
        that.needDetail = false;
      }*/

      if (isDetail) {
        that.needDetail = true
      } else {
        that.needDetail = false
      }

      let checkIndex = that.checkCacheAvailable()
      let lng, lat
      for (let i = 0; i < that.cacheList.length; i++) {
        if (that.cacheList[i]['tipID']) {
          let tmpNode = $('#' + that.cacheList[i]['tipID'])
          if (tmpNode.length > 0) {
            tmpNode.fadeOut(0)
          }
        }
      }
      $(this.$refs.infoDetail).fadeOut(0)
      $(this.$refs.infoHistory).fadeOut(0)
      if (
        that.playList &&
        that.playList.length > 0 &&
        /*window.g_bme3dManager &&
        window.g_bme3dManager.earth &&*/
        !this.$isStop.status
      ) {
        if (checkIndex >= 0) {
          if (that.$isStop.status || that.stopIndex === checkIndex) {
            return
          }

          if (that.playList.length > 0) {
            that.warnIdx = 0
            let obj = that.playList.shift()
            let cacheObj = that.cacheList[checkIndex]
            if (!$.isEmptyObject(cacheObj)) {
              lng = obj['lng']
              lat = obj['lat']
              cacheObj['lng'] = obj['lng']
              cacheObj['lat'] = obj['lat']
              cacheObj['status'] = 'play'
              cacheObj['data'] = obj['data']
              cacheObj['type'] = obj['type']
              cacheObj['typeId'] = obj['typeId']
              //cacheObj["workTicketNo"] = obj["workTicketNo"];
              //$("#" + cacheObj["tipID"]).hide();

              if ((cacheObj['lng'] && cacheObj['lat']) || !cacheObj['lng'] || !cacheObj['lat']) {
                // by 刘阳洋 有些设备无坐标
                try {
                  that.drawTip(
                    cacheObj['tipID'],
                    cacheObj['data']['workTicketNo'],
                    cacheObj['lng'],
                    cacheObj['lat'],
                    bmeConfig.altitude,
                    checkIndex,
                    window.g_bme3dManager ? g_bme3dManager.earth : '',
                    obj,
                    checkIndex
                  )
                } catch (err) {
                  console.log(err)
                }
              } else {
                that.timeoutClear()
                if (that.restoreWarnTimer) {
                  clearTimeout(that.restoreWarnTimer)
                }
                that.restoreWarnTimer = setTimeout(function () {
                  that.renderPlay(isDetail)
                }, 50)
              }
            } else {
              that.timeoutClear()
              if (that.restoreWarnTimer) {
                clearTimeout(that.restoreWarnTimer)
              }
              that.restoreWarnTimer = setTimeout(function () {
                that.renderPlay(isDetail)
              }, 50)
            }
          } else {
            that.warnIdx = checkIndex
            let cacheObj = that.cacheList[checkIndex]
            if (!$.isEmptyObject(cacheObj)) {
              lng = cacheObj['lng']
              lat = cacheObj['lat']
              if (cacheObj['lng'] && cacheObj['lat']) {
                try {
                  // 初次进入
                  that.drawTip(
                    cacheObj['tipID'],
                    cacheObj['data']['workTicketNo'],
                    cacheObj['lng'],
                    cacheObj['lat'],
                    bmeConfig.altitude,
                    checkIndex,
                    window.g_bme3dManager ? g_bme3dManager.earth : '',
                    obj
                  )
                } catch (err) {
                  console.log(err)
                }
              } else {
                that.timeoutClear()
                if (that.restoreWarnTimer) {
                  clearTimeout(that.restoreWarnTimer)
                }
                that.restoreWarnTimer = setTimeout(function () {
                  that.renderPlay(isDetail)
                }, 50)
              }
            } else {
              that.timeoutClear()
              if (that.restoreWarnTimer) {
                clearTimeout(that.restoreWarnTimer)
              }
              that.restoreWarnTimer = setTimeout(function () {
                that.renderPlay(isDetail)
              }, 50)
            }
          }

          let allAvailible = true
          that.cacheList.forEach((obj, n) => {
            if (obj.status != 'wait') {
              allAvailible = false
            }
          })
          let curTime = new Date().getTime()
          //停止大于10秒钟并且所有
          // console.log(
          //   "停止大于10秒钟并且所有",
          //   curTime - this.stopTime,
          //   allAvailible
          // );
          if (curTime - that.stopTime > 6000 && this.$route.name === 'DutyMod') {
            that.$isStop.status = false
            that.stopIndex = -1
          }

          /*let deltaTime = that.needDetail ? 20 : 8; //parseInt(Math.random() * 3 + 5);
          if (that.$dutyTimer[checkIndex] && that.$dutyTimer[checkIndex]["renderTimer"]) {
            clearTimeout(that.$dutyTimer[checkIndex]["renderTimer"]);
          } else {
            deltaTime = 3;
          }

          if (checkIndex > 0) {
            that.$dutyTimer[checkIndex]["renderTimer"] = setTimeout(function () {
              if (window.g_bme3dManager && window.g_bme3dManager.earth) {
                const earth = window.g_bme3dManager.earth;
                let view =
                  mapViews[`mapViews_${that.customerId}`] &&
                  mapViews[`mapViews_${that.customerId}`].dutyMod;
                if (view && view.length) {
                  earth.camera.flyTo(view[0], view[1], view[2], 0.5);
                }
              }
            }, 1000);
          } else {
            if (window.g_bme3dManager && window.g_bme3dManager.earth) {
              const earth = window.g_bme3dManager.earth;
              let view =
                mapViews[`mapViews_${that.customerId}`] &&
                mapViews[`mapViews_${that.customerId}`].dutyMod;
              if (view && view.length) {
                earth.camera.flyTo(view[0], view[1], view[2], 0.5);
              }
            }
          }*/
        } else {
          /*if (that.$dutyTimer[checkIndex] && that.$dutyTimer[checkIndex]["renderTimer"]) {
            clearTimeout(that.$dutyTimer[checkIndex]["renderTimer"]);
          }
          if (checkIndex < 0) {
            that.renderPlay();
          } else {
            that.$dutyTimer[checkIndex]["renderTimer"] = setTimeout(function () {
              that.renderPlay();
            }, 1000);
          }*/
          that.timeoutClear()
          if (that.restoreWarnTimer) {
            clearTimeout(that.restoreWarnTimer)
          }
          that.restoreWarnTimer = setTimeout(function () {
            that.renderPlay()
          }, 50)
        }
      } else {
        /*if (that.$dutyTimer[checkIndex] && that.$dutyTimer[checkIndex]["renderTimer"]) {
          clearTimeout(that.$dutyTimer[checkIndex]["renderTimer"]);
        }
        if (checkIndex < 0) {
          that.renderPlay();
        } else {
          that.$dutyTimer[checkIndex]["renderTimer"] = setTimeout(function () {
            that.renderPlay();
          }, 1000);
        }*/
        that.timeoutClear()
        if (that.restoreWarnTimer) {
          clearTimeout(that.restoreWarnTimer)
        }
        that.restoreWarnTimer = setTimeout(function () {
          that.renderPlay()
        }, 50)
      }
    },
    async getFindSpread(deviceNo) {
      //https://vis.bmetech.com/vis/homePage/findSpread?deviceNo=BMEPMLED18090508
      let getFindSpreadUrl = CONFIG.requestName + this.$apiOpt.findSpread
      let data = await this.$apiUtils.get(getFindSpreadUrl, {
        deviceNo: deviceNo
      })
      return data
    },
    async getDevicePos(deviceNo, warnType) {
      let getDevice = CONFIG.requestName + this.$apiOpt.getDevice
      let params = {
        deviceNo: deviceNo
      }
      if (warnType == 5) {
        getDevice = CONFIG.requestName + this.$apiOpt.getRoadLocation
        params = {
          roadId: deviceNo
        }
      }

      let data = await this.$apiUtils.get(getDevice, params)
      let devicePos = {}
      if (data) {
        if (warnType == 5) {
          devicePos = {
            longitude: data.startLnd || 0,
            latitude: data.startLat || 0
          }
        } else {
          devicePos = {
            longitude: data.longitude || 0,
            latitude: data.latitude || 0
          }
        }
      } else {
        devicePos = {
          longitude: 0,
          latitude: 0
        }
      }
      if (!devicePos.longitude && !devicePos.latitude && this.customerId == 42) {
        devicePos = {
          longitude: 1,
          latitude: 1
        }
      }
      return devicePos
    },
    // 获取道路经纬度
    async getRoadLocation(deviceNo) {
      let getDevice = CONFIG.requestName + this.$apiOpt.getRoadLocation
      let data = await this.$apiUtils.get(getDevice, {
        deviceNo: deviceNo
      })
      let devicePos = {}
      if (data) {
        devicePos = {
          longitude: data.longitude || 0,
          latitude: data.latitude || 0
        }
      } else {
        devicePos = {
          longitude: 0,
          latitude: 0
        }
      }
      return devicePos
    },

    checkCachePointAvailable() {
      let num = -1
      try {
        this.cachePointList.forEach((obj, n) => {
          if (obj.status == 'wait') {
            num = n
            throw Error('有空闲')
          }
        })
      } catch (err) {
        console.log('有空闲')
      }
      return num
    },
    checkCacheAvailable() {
      let num = -1
      try {
        this.cacheList.forEach((obj, n) => {
          if (obj.status == 'wait') {
            num = n
            throw Error('有空闲')
          }
        })
      } catch (err) {
        // console.log("有空闲");
      }
      return num
    },
    updateDutyInventoryId(val) {
      this.dutyInventoryId = val
    },
    updateDutyInventoryName(val) {
      this.dutyInventoryName = val
    },
    rowClick(row, column, event) {
      let inventoryId = row.inventoryId
      let inventoryName = row.emName

      this.deviceStatus = true
      this.stopWarning()
      this.$forceUpdate()
      /*this.updateFactoryArea(this.branchFactoryId, this.emNameVal, true);*/
      this.$nextTick(() => {
        this.updateDutyInventoryId({
          inventoryId: inventoryId,
          inventoryName: inventoryName
        })
      })
      //this.updateDutyInventoryName(inventoryName);
    },
    rowClickRecover() {
      let that = this
      this.deviceStatus = false
      //this.restoreWarning();

      if (this.restoreWarnTimer) {
        clearTimeout(this.restoreWarnTimer)
      }
      this.restoreWarnTimer = setTimeout(function () {
        that.stopIndex = -1
        that.$isStop.status = false
        that.timeoutClear()
        if ($('.emission_table').length > 0) {
          $('.emission_table').fadeOut(600)
        }
        that.renderPlay()
      }, 5000)
    }
  }
}
</script>
<style lang="scss" scoped="scoped">
.warn1_title {
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid;
  border-image: linear-gradient(-90deg, #4fa7ff, #88f7ff) 1 1;
  justify-content: space-between;
  .popup-type1-title {
    height: 30px;
    font-size: 22px;
    font-weight: 500;
    color: #ff7373;
    line-height: 30px;
    display: flex;
    align-items: center;
    &::before {
      content: '';
      display: block;
      width: 7px;
      height: 7px;
      background: #ff7373;
      box-shadow: 0px 0px 7px 0px #df3131;
      border: 1px solid #da3636;
      border-radius: 50%;
      display: inline-block;
      margin-right: 16px;
    }
  }
  .popup-type1-time {
    // height: 14px;
    padding-bottom: 5px;
    font-size: 14px;
    color: #ffffff;
    line-height: 14px;
  }
}
.infoDetail {
  position: fixed;
  //top: 120px;
  //left: calc(50% - 215px);
  z-index: 998;
  display: none;
}
.pointerEvents {
  pointer-events: all;
}
.upgrade {
  display: none;
  margin-left: -360px;
  margin-top: -150px;
  width: 350px;
  padding: 10px 10px 55px;
  background: linear-gradient(320deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.6) 40%, rgba(0, 0, 0, 1));
  position: relative;
  box-shadow: 2px 2px 15px #01122b;
  ul {
    position: absolute;
    top: 45px;
    left: 100px;
    height: 100%;

    li {
      height: 80px;
      width: 200px;
      margin-bottom: 15px;
      .upgrade-wrap {
        display: flex;
        align-items: flex-start;
      }

      .upgrade_pic {
        display: inline-block;
        vertical-align: top;
        img {
          width: 60px;
        }
      }
      .upgrade_person {
        display: inline-block;
        vertical-align: top;
        margin-left: 10px;
      }
    }
  }
}

.noArcgis {
  opacity: 0;
}

.upgrade-lineSteps {
  width: 280px;
  height: 400px;
  margin-top: 20px;
}

.infoHistory {
  position: fixed;
  //top: calc(50% + 200px);
  //left: calc(50% + 100px);
  z-index: 998;
  display: none;
  width: 500px;
  height: 220px;
  padding: 10px 30px 35px 30px;
  background: linear-gradient(45deg, rgba(0, 0, 0.8), rgba(0, 0, 0, 0.3));
  border-radius: 15px;
  transform-origin: top left;
  transform: scale(0.01);
}

.infoHistoryNew {
  height: 430px;
}

.infoHistoryNew1 {
  height: 260px;
}

.infoHistory-large {
  transform: scale(1) !important;
  transition: all 0.75s linear 0.25s;
}

.historyChart {
  position: relative;
  width: 100%;
  height: 100%;
}

.charts-title {
  color: #94a2b0;
  font-size: 18px;
  line-height: 30px;
  margin: 10px 0;
}

.historyChart1 {
  position: relative;
  width: 100%;
  height: 140px;
}

.historyChart2 {
  position: relative;
  width: 100%;
  height: 140px;
}

.warn1-Tiny {
  transform: scale(0.01);
  transform-origin: bottom center;
}

.warn1-large {
  transform: scale(1) !important;
  transition: all 0.75s linear 0s;
}

.warn_innerBlock {
  position: fixed;
  width: 450px;
  height: 732px;
}

.warn_block {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 100%;
}
.md-modal {
  z-index: 10001;
}
.md-content {
  padding: 75px 100px;
  background: rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 10px 5px #ccc;
}
.pointerEventAll {
  pointer-events: all;
}
.test {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  //pointer-events: auto;
  overflow: hidden;
  .processComponent {
    .everyComponent {
      ul {
        width: 100%;
        height: 100%;
        pointer-events: auto;
        .ComponentTip_ {
          background-size: 100% 100%;
          width: 46px;
          height: 46px;
          position: absolute;
          pointer-events: auto;
          img {
            animation: twinkle 1.5s;
            animation-iteration-count: infinite;
            // transform-origin: top center;
            animation-timing-function: linear;
          }
          .green {
            width: 100%;
            position: absolute;
            bottom: 0px;
            position: absolute;
          }
          .red {
            width: 100%;
            position: absolute;
            bottom: 0px;
            position: absolute;
          }
        }
        .DustTip {
          background-size: 100% 100%;
          //background: red;
          width: 50px;
          height: 50px;
          position: absolute;
          display: none;
          img {
            position: absolute;
            width: 50px;
            height: 50px;
          }
        }
        .ComponentTip {
          // background:  url('./img/1.png') no-repeat;
          background-size: 100% 100%;
          //background: red;
          width: 500px;
          height: 320px;
          position: absolute;
          display: none;
          // pointer-events: auto;

          div {
            .img-title {
              width: 100%;
              position: absolute;
              bottom: 150px;
              z-index: 1;
              background: url(./img/xk.png) no-repeat left top;
              background: url(./img/sk.png) no-repeat left bottom;
            }
            .img2 {
              width: 100%;
              animation: circleScale 1.5s;
              animation-iteration-count: infinite;
              transform-origin: top center;
              animation-timing-function: linear;
              position: absolute;
              bottom: -400px;
              //left: 25%;
            }
            .img-Image {
              width: 100%;
              position: absolute;
              bottom: 100px;
            }
            .img-video {
              width: 100%;
              position: absolute;
              bottom: 100px;
            }
            .warn1 {
              width: 100%;
              position: absolute;
              bottom: 100px;
            }
            .warn2 {
              width: 100%;
              position: absolute;
              bottom: 750px;
            }
            .warn3 {
              width: 100%;
              position: absolute;
              bottom: 700px;
            }
            .green {
              width: 100%;
              transform: scale(0.1);
              position: absolute;
              bottom: -120px;
            }
            .red {
              width: 100%;
              transform: scale(0.1);
              position: absolute;
              bottom: -120px;
            }
          }
        }
      }
    }
  }
}
@keyframes circleScale {
  0% {
    transform: rotateX(105deg) scale(0.1);
  }
  // 50% {
  //   transform: translateY(110px) rotateX(105deg) scale(0.75);
  // }
  100% {
    transform: rotateX(105deg) scale(0.3);
  }
}

@keyframes twinkle {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.dustReason {
  background-image: url('./img/panelView_2_2.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 400px;
  height: 200px;
  position: absolute;
  top: -250px;
  left: -200px;
  padding: 20px 30px;
  font-size: 22px;
  font-family: 'fontNormal';

  .dustReasonTitle {
    font-size: 28px;
    font-family: 'bigTitle';
    text-align: center;
    font-weight: bolder;
    margin-bottom: 20px;
  }
}

.dustReasonBlack {
  background-image: url('./img/panelView_blueBg_2_2.png');
}

.dustRotate {
  display: none;
  filter: blur(0px) opacity(0.8) grayscale(1) invert(0);
}

.dustAnimate {
  animation: dustTwinkle 2s;
  animation-iteration-count: infinite;
  animation-direction: alternate-reverse;
  // transform-origin: top center;
  animation-timing-function: ease-in-out;
}

@keyframes dustTwinkle {
  0% {
    filter: blur(0px) opacity(0.8) grayscale(1) invert(0);
  }
  25% {
    filter: blur(0.25px) opacity(0.8) grayscale(1) invert(0.25);
  }
  50% {
    filter: blur(0.5px) opacity(0.8) grayscale(1) invert(0.5);
  }
  75% {
    filter: blur(0.25px) opacity(0.8) grayscale(1) invert(0.75);
  }
  100% {
    filter: blur(0px) opacity(0.8) grayscale(1) invert(1);
  }
}

#mvideo {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
}
.ddd {
  width: 46px;
  height: 46px;
  background-color: skyblue;
  position: absolute;
}

.topLeft {
  transform-origin: top left;
  -webkit-transform-origin: top left;
}

.topRight {
  transform-origin: top right;
  -webkit-transform-origin: top right;
}

.bottomLeft {
  transform-origin: bottom left;
  -webkit-transform-origin: bottom left;
  //left: 750px !important;
  //bottom: 50px !important;
  //transform: scale(1, 1) translate(750px, 100px) !important;
 
}

.bottomRight {
  transform-origin: bottom right;
  -webkit-transform-origin: bottom right;
  //left: calc(100% - 1150px) !important;
  //bottom: 50px !important;
  //transform: scale(1, 1) translate(calc(100% - 1150px), 100px) !important;
  
}
</style>

<style lang="scss">
.emission_table {
  width: 650px;
  position: absolute;
  pointer-events: all;
  display: none;
  background: linear-gradient(269deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.6) 40%, black) !important;
  .source_table {
    border: 1px solid #84aaff40 !important;
    background: #01132d40 !important;
  }
  .thClass {
    background: #01122ba6 !important;
    border-bottom: 1px solid #cccccc28 !important;
  }

  .thClass > .cell {
    font-size: 16px !important;
    color: #47ffddff !important;
    font-family: 'fontNormal' !important;
    text-align: center !important;
  }

  .thClass_ {
    background: #01122ba6 !important;
    border-right: 1px solid rgba(132, 170, 255, 0.5) !important;
    border-bottom: 1px solid #cccccc28 !important;
  }

  .thClass_ > .cell {
    font-size: 16px !important;
    color: #bbbbbbff !important;
    font-family: 'fontNormal' !important;
    text-align: center !important;
  }

  .tdClass {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #01122b66 !important;
  }
  .tdClass > .cell {
    font-size: 16px !important;
    color: #bbbbbbff !important;
    font-family: 'fontNormal' !important;
    text-align: center !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .tdClass_ {
    border-right: 1px solid #84aaff40 !important;
    border-bottom: 1px solid #84aaff40 !important;
    background: #0b336b40 !important;
  }

  .tdClass_ > .cell > div {
    font-size: 16px !important;
    color: #888888ff !important;
    font-family: 'fontNormal' !important;
    text-align: center !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .headTrClass {
    border: 1px solid rgba(132, 170, 255, 0.5) !important;
  }
}
</style>

<style scoped lang="scss">
.allListBtn {
  color: #4be0ff;
  position: absolute;
  right: 50px;
  top: 50px;
}

.green-dot {
  color: #99f5ffff;
  line-height: 16px;
  font-size: 30px;
}

.red-dot {
  color: #ff7f7fff;
  line-height: 16px;
  font-size: 30px;
}

.gray-dot {
  color: #cccccccc;
  line-height: 16px;
  font-size: 30px;
}

.dot1 {
  font-size: 60px;
  color: #99f5ffff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
}

.dot2 {
  font-size: 60px;
  color: #4d4d4dff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot3 {
  font-size: 60px;
  color: #ff7f7fff;
  display: inline-block;
  vertical-align: middle;
  height: 40px;
  line-height: 30px;
  margin-left: 20px;
}

.dot1-title {
  font-size: 16px;
  font-family: 'fontNormal';
  color: #c8dde1ff;
  display: inline-block;
  line-height: 50px;
  height: 40px;
}
</style>
